import http from './api'

const route = 'app/comercial/vendas3/'

export default {
  showEvolucaoVendasPrecoMedio: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendasPrecoMedio', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showPrecoMedio7MesesAnteriores: (empresas, supervisor, tokencontrato) => {
    return http.post(route + 'showPrecoMedio7MesesAnteriores', {
      empresas: empresas,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
    })
  },

  showFatVendas: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFatVendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatMesAnoAnterior: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFatMesAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFat7MesesAnteriores: (select, supervisor, tokenContrato) => {
    return http.post(route + 'showFat7MesesAnteriores', {
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatMesesDoAno: (select, supervisor, tokenContrato) => {
    return http.post(route + 'showFatMesesDoAno', {
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatPrincipaisClientes: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFatPrincipaisClientes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFatProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showEvolucaoVendas3Volume: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendas3VolumeSupervisor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showVendas3Devolucao: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showVendas3Devolucao', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showVendas3DevolucaoAnoAnterior: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showVendas3DevolucaoAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoVendas3Produtos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDelhamentoVendas3Produtos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDetalheVendas3PrincipaisClientes: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showDetalheVendas3PrincipaisClientes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoDevolucaoVendas3: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDelhamentoDevolucaoVendas3', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoDevolucaoAnoAnteriorVendas3: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDelhamentoDevolucaoAnoAnteriorVendas3', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },
}
